/**
 * Canonical assessment status lists for dropdown, filters, badges, and timeline.
 * Ticket 14744 — keep legacy aliases in filters so existing rows remain findable.
 */

/** Admin status dropdown (CheckedDropdown). Order ≈ workflow; not strictly sequential. */
export const ASSESSMENT_STATUS_DROPDOWN = [
  { title: "Request Declined" },
  { title: "Request Accepted" },
  { title: "Intro Email Sent" },
  { title: "Intro Meeting Complete" },
  { title: "Scope Defined" },
  { title: "Assessment Scheduled" },
  { title: "Assessment in Progress" },
  { title: "Assessment Complete" },
  { title: "In Peer Review" },
  { title: "In Sponsor Review" },
  { title: "Final Report Delivered" },
  { title: "Pending Observation Response" },
  { title: "Observation Response In Review" },
  { title: "Published to Library" },
  { title: "Assessment Closed" },
  { title: "Canceled Assessment" },
];

/** Sort / rank order for grids (includes legacy strings). */
export const VQA_STATUS_ORDER = [
  "Pending Diligent Review",
  "Request Accepted",
  "Intro Email Sent",
  "Intro Meeting Complete",
  "Planning Meeting Complete",
  "Scope Defined",
  "Auditor Assigned",
  "Assessment Scheduled",
  "Assessment in Progress",
  "Assessment Complete",
  "Assessment Completed",
  "In Peer Review",
  "Draft Report Delivered",
  "Draft Review by Client",
  "In Sponsor Review",
  "Final Report Delivered",
  "Pending Observation Response",
  "Observation Response In Review",
  "Report Anonymized",
  "Report Published to Library",
  "Published to Library",
  "Assessment Closed",
  "Cancelled",
  "Canceled Assessment",
  "Archived",
];

/** Filter option shape used by admin/sponsor/provider assessment grids. */
export function buildAssessmentStatusFilterOptions() {
  return [
    { statusID: "Pending Diligent Review", label: "Pending Diligent Review", checked: false },
    { statusID: "Request Accepted", label: "Request Accepted", checked: false },
    { statusID: "Intro Email Sent", label: "Intro Email Sent", checked: false },
    { statusID: "Intro Meeting Complete", label: "Intro Meeting Complete", checked: false },
    { statusID: "Scope Defined", label: "Scope Defined", checked: false },
    { statusID: "Planning Meeting Complete", label: "Planning Meeting Complete", checked: false },
    { statusID: "Assessment Scheduled", label: "Assessment Scheduled", checked: false },
    { statusID: "Assessment in Progress", label: "Assessment in Progress", checked: false },
    { statusID: "Assessment Complete", label: "Assessment Complete", checked: false },
    { statusID: "In Peer Review", label: "In Peer Review", checked: false },
    { statusID: "In Sponsor Review", label: "In Sponsor Review", checked: false },
    { statusID: "Draft Review by Client", label: "Draft Review by Client", checked: false },
    { statusID: "Final Report Delivered", label: "Final Report Delivered", checked: false },
    { statusID: "Pending Observation Response", label: "Pending Observation Response", checked: false },
    { statusID: "Observation Response In Review", label: "Observation Response In Review", checked: false },
    { statusID: "Published to Library", label: "Published to Library", checked: false },
    { statusID: "Report Published to Library", label: "Report Published to Library", checked: false },
    { statusID: "Report Anonymized", label: "Report Anonymized", checked: false },
    { statusID: "Assessment Closed", label: "Assessment Closed", checked: false },
    { statusID: "Cancelled", label: "Cancelled", checked: false },
    { statusID: "Archived", label: "Archived", checked: false },
  ];
}

export const STATUS_INDICATOR_BLUE = ["Pending Diligent Review"];
export const STATUS_INDICATOR_GREEN = [
  "Final Report Delivered",
  "Assessment Closed",
  "Published to Library",
  "Report Published to Library",
];
export const STATUS_INDICATOR_RED = [
  "Cancelled",
  "Canceled Assessment",
  "Request Declined",
  "Denied",
];
export const STATUS_INDICATOR_YELLOW = [
  "Request Accepted",
  "Intro Email Sent",
  "Intro Meeting Complete",
  "Planning Meeting Complete",
  "Scope Defined",
  "Auditor Assigned",
  "Assessment Scheduled",
  "Assessment in Progress",
  "Assessment Complete",
  "Assessment Completed",
  "In Peer Review",
  "In Sponsor Review",
  "Draft Review by Client",
  "Pending",
  "Draft Report Delivered",
  "Sponsor Draft Report Available",
  "Pending Observation Response",
  "Observation Response In Review",
  "Report Anonymized",
];
